<section class="reports-page">
  <header class="page-header">
    <div>
      <span class="eyebrow">Read-only analytics</span>
      <h1>Reports</h1>
      <p>This screen summarizes the data currently stored in local storage.</p>
    </div>

    <button type="button" routerLink="/dashboard" class="nav-button">
      Back to dashboard
    </button>
  </header>

  <div class="report-hero">
    <article class="summary-card">
      <span>Total order value</span>
      <strong>{{ getOrderValue() | currency:'USD':'symbol':'1.0-0' }}</strong>
    </article>
    <article class="summary-card">
      <span>Collections tracked</span>
      <strong>{{ entityOrder.length }}</strong>
    </article>
  </div>

  <div class="report-grid">
    <article class="report-card" *ngFor="let entity of entityOrder">
      <span class="report-label">{{ entityConfigs[entity].title }}</span>
      <h2>{{ getCount(entity) }} records</h2>
      <p>{{ entityConfigs[entity].description }}</p>
      <div class="latest-record" *ngIf="getLatestRecord(entity) as latestRecord">
        <span>Latest entry</span>
        <strong>{{ latestRecord[entityConfigs[entity].formFields[0].key] }}</strong>
      </div>
      <a [routerLink]="['/records', entity]">Open module</a>
    </article>
  </div>
</section>